import classNames from 'classnames';
import type * as React from 'react';

export interface RowProps extends React.HTMLAttributes<HTMLElement> {
  /** Make the html be a different tag, such as `<span>` */
  tag?: any;
  /** If set to true, removes the gutters between columns */
  noGutters?: boolean;
  /** Applies form styling to the row */
  form?: boolean;
  /** If set to true, elements are vertically aligned to the top of the Row. Must be used along with the `form` prop. */
  alignTop?: boolean;
  /** If set to true, elements are vertically aligned to the middle of the Row. Cannot be used with the `form` prop. */
  alignMiddle?: boolean;
  /** Identifier used by QE */
  'data-qe-id'?: string;
}

const defaultProps: Partial<RowProps> = {
  tag: 'div',
  noGutters: false,
  form: false,
  alignTop: false,
  alignMiddle: false,
  'data-qe-id': undefined,
};

export const Row: React.FC<RowProps> = (props) => {
  const {
    className,
    noGutters,
    tag: Tag = 'div',
    form,
    alignTop,
    alignMiddle,
    'data-qe-id': qeId,
    ...attributes
  } = props;

  const classes = classNames(
    className,
    { 'no-gutters': noGutters },
    { 'form-row': form },
    { 'form-row-align-top': alignTop },
    { 'row-align-middle': alignMiddle },
    { row: !form }
  );

  return <Tag {...attributes} className={classes} data-qe-id={qeId} />;
};

Row.defaultProps = defaultProps;
Row.displayName = 'Row';

export default Row;
